<template>
	<dialog
		ref="dialogRef"
		class="fixed top-0 mr-0 right-0 max-w-full p-8 bg-transparent backdrop:bg-transparent focus:outline-none z-50 max-w-screen"
	>
		<TransitionGroup
			name="notification-list"
			tag="ul"
			class="flex flex-col gap-4 sticky top-60 lg:top-40 pl-0"
		>
			<MoleculeNotication
				v-for="notification of notifications"
				:key="notification.message"
				:notification="notification"
			/>
		</TransitionGroup>
	</dialog>
</template>

<script lang="ts" setup>
const {
	notifications,
} = useNotifications();

const dialogRef = ref<HTMLDialogElement>();

const openOrClose = () => {
	if (notifications.length > 0) {
		dialogRef.value?.show();
	}
	else {
		setTimeout(() => {
			dialogRef.value?.close();
		}, 250);
	}
};

onMounted(() => {
	openOrClose();
});

watch(notifications, () => {
	openOrClose();
});
</script>

<style lang="postcss" scoped>
.notification-list-enter-active,
.notification-list-leave-active {
    @apply translate-x-0 transition-all;
}
.notification-list-enter-from,
.notification-list-leave-to {
    @apply translate-x-full;
}
</style>
